module.exports = __webpack_public_path__ + "assets/35941c720d2376b023ccf21d4d1f7693.png";